import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <h2 className="about-title">ABOUT US</h2>
      <p className="about-text">
        TFH atau The Family Haven adalah salah satu clan atau keluarga di server ProwNetwork..
      </p>
    </section>
  );
};

export default About;
